import React, { useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import SeatIconPath from './seat.svg';
import CupraIconPath from './cupra-logo.svg';
import './CupraLogo.scss';

const CupraLogo = ({
    classNames,
}) => {
    const seatRef = useRef<HTMLImageElement>(null);

    const [separatorHeight, setSeparatorHeight] = useState(0);
    useLayoutEffect(() => {
        if (seatRef.current) {
            const seatIconHeight = seatRef.current.clientHeight;
            setSeparatorHeight(seatIconHeight);
        }
    }, [seatRef]);

    const classes = classnames('b-cupra-logo', classNames);
    return (
        <div className={classes}>
            <img src={SeatIconPath} width="100px" height="61px" ref={seatRef} />
            <div className="vertical-separator" style={{ height: `${separatorHeight}px` }} />
            <img 
                width={100} 
                height={85} 
                style={{ transform: 'translateY(-5px)' }} 
                src={CupraIconPath}
                alt="Cupra Logo"
                data-testid="cupra-logo"
            />
        </div>
    );
};

export default CupraLogo;

